var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMembersWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M7.12109 6.85547C7.12109 4.25938 8.81526 2.05938 11.1582 1.29965C10.5759 1.11102 9.96756 1.01517 9.35547 1.01563C6.1302 1.01563 3.51562 3.6302 3.51562 6.85547C3.51562 10.0807 6.1302 12.6953 9.35547 12.6953C9.98465 12.6953 10.5904 12.5954 11.1582 12.4113C8.81526 11.6516 7.12109 9.45156 7.12109 6.85547Z",
    fill: "url(#paint0_linear_181_682)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9922 26C18.4313 26 17.9766 25.5453 17.9766 24.9844C17.9766 21.0083 14.7417 17.7734 10.7656 17.7734H9.24219C5.26607 17.7734 2.03125 21.0083 2.03125 24.9844C2.03125 25.5453 1.57655 26 1.01562 26C0.454695 26 0 25.5453 0 24.9844C0 19.8882 4.14604 15.7422 9.24219 15.7422H10.7656C15.8618 15.7422 20.0078 19.8882 20.0078 24.9844C20.0078 25.5453 19.5531 26 18.9922 26Z",
    fill: "url(#paint1_linear_181_682)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90234 13.7109C6.12224 13.7109 3.04688 10.6356 3.04688 6.85547C3.04688 3.07536 6.12224 0 9.90234 0C13.6824 0 16.7578 3.07536 16.7578 6.85547C16.7578 10.6356 13.6824 13.7109 9.90234 13.7109ZM9.90234 2.03125C7.24227 2.03125 5.07812 4.19539 5.07812 6.85547C5.07812 9.51554 7.24227 11.6797 9.90234 11.6797C12.5624 11.6797 14.7266 9.51554 14.7266 6.85547C14.7266 4.19539 12.5624 2.03125 9.90234 2.03125Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_682",
    x1: 3.51562,
    y1: 1.01562,
    x2: 13.5426,
    y2: 10.0484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_181_682",
    x1: 0,
    y1: 15.7422,
    x2: 5.79159,
    y2: 31.2942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersWhite);
export default __webpack_public_path__ + "static/media/membersWhite.97cbd3d1a1091b805baa02b64d90984c.svg";
export { ForwardRef as ReactComponent };